import { Pipe } from '@angular/core';
import { isObject } from '../helpers/helpers';
var InvertByPipe = (function () {
    function InvertByPipe() {
    }
    InvertByPipe.prototype.transform = function (obj, cb) {
        if (Array.isArray(obj) || !isObject(obj)) {
            return obj;
        }
        return Object.keys(obj).reduce(function (o, k) {
            var key = cb ? cb(obj[k]) : obj[k];
            return Array.isArray(o[key])
                ? (o[key].push(k), o)
                : Object.assign(o, (_a = {}, _a[key] = [k], _a));
            var _a;
        }, {});
    };
    return InvertByPipe;
}());
export { InvertByPipe };
InvertByPipe.decorators = [
    { type: Pipe, args: [{ name: 'invertBy' },] },
];
/** @nocollapse */
InvertByPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=invert-by.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/object/invert-by.js
// module id = 248
// module chunks = 4